import src from "./bouqsLogo.png";
export default { src: src, aspect: 1.8311, width: 1236, height: 675 };